import React from "react";

export default function CommentsPublic({ addData }) {
  const onChange = (e) => {
    const { value, id } = e.target;

    addData(id, value);
  };
  return (
    <div className="m-4">
      <label className="block mb-2">
        <span>Public Comments</span>
        <textarea
          className="block p-2 text-sm w-4/5 text-gray-900 bg-gray-50 border-orange-400 rounded-lg border focus:border-orange-400"
          id="commentsPublic"
          rows="4"
          onChange={onChange}
          name="commentsPublic"
        />
      </label>
    </div>
  );
}
